import http from '../shared/HttpCommon';

const getCompanyName = async (platformID: number, url: string) => {
  try {
    const { data } = await http.post('/platforms/company', {
      platformID: platformID,
      uri: url,
    });
    const { company } = data;
    return company;
  } catch (error) {
    console.error(error);
  }
};

const CompanyNameService = {
  getCompanyName,
};

export default CompanyNameService;
